var map = {
	"./template-01.jpg": "6447",
	"./template-02.jpg": "052f",
	"./template-03.jpg": "da1b",
	"./template-04.jpg": "40e7",
	"./template-05.jpg": "8eaf",
	"./template-06.jpg": "67f1",
	"./template-07.jpg": "fc9c",
	"./template-08.jpg": "c414"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b5a1";